import { Reveal } from "../components/Reveal";
import { CallButton, WhatsAppButton } from "../components/Buttons";
import { useLang } from "../lib/i18n";

export const ClosingCTA = () => {
  const { t } = useLang();
  return (
  <section data-testid="closing-cta-section" className="relative overflow-hidden border-t border-edge/40">
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[820px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#f3efe4] blur-[130px]" />
    <div className="relative mx-auto max-w-7xl px-6 py-24 text-center md:px-12 md:py-32 lg:px-20">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-faint">Beyond The Ordinary</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mx-auto mt-5 max-w-3xl font-archivo text-3xl font-black tracking-tight text-cream md:text-5xl" data-testid="closing-cta-heading">
          {t.closingHeading}
        </h2>
      </Reveal>
      <Reveal delay={0.18}>
        <p className="mx-auto mt-5 max-w-md text-sm leading-relaxed text-tan sm:text-base">
          {t.closingCopy}
        </p>
      </Reveal>
      <Reveal delay={0.26}>
        <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
          <CallButton label={t.callNow} testid="closing-call-button" />
          <WhatsAppButton label={t.whatsappUs} testid="closing-whatsapp-button" />
        </div>
      </Reveal>
    </div>
  </section>
  );
};
